module.exports = __webpack_public_path__ + "img/word_sausage_mask.8f3b0c66.svg";